/**
 * A small helper to return some height constraints.
 */
export function getHeightConstraints(screenHeight: number) {
  const isSM = screenHeight < SMALL_HEIGHT_MIN;

  return { isSM, isLG: !isSM };
}

const SMALL_HEIGHT_MIN = 720;
